import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';

import { updateVideoPlayerMouseActive } from 'actions/videoPlayer';
import { ROOT_CLASS } from 'constants/videoPlayer';

function CaptureMouse({
  onMouseMove,
  fullScreen,
  children,
  stylesFromShareVideoParent,
  iframeVisible,
  onMouseLeave,
  reference,
  mouseActive,
  updateVideoPlayerMouseActive,
}) {
  function mouseMoved() {
    onMouseMove();

    if (mouseActive === false) {
      return updateVideoPlayerMouseActive();
    }
  }

  return (
    <div
      className={classnames(ROOT_CLASS, { fullScreen })}
      onMouseMove={mouseMoved}
      onMouseDown={mouseMoved}
      onTouchMove={mouseMoved}
      onMouseLeave={onMouseLeave}
      style={{
        ...stylesFromShareVideoParent,
        visibility: iframeVisible ? 'visible' : 'hidden',
      }}
      ref={reference}
    >
      {children}
    </div>
  );
}

const mapStateToProps = state => {
  const { mouse_active: mouseActive } = state.video_player;

  return {
    mouseActive,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateVideoPlayerMouseActive: () =>
      dispatch(updateVideoPlayerMouseActive()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CaptureMouse);
